import React from 'react';
import { LuCamera, LuLink, LuLoaderCircle } from 'react-icons/lu';
import Badge from '../ui/Badge';
import { formatDays, formatParisInstant, isSnapshot } from '../../utils/weekFormat.js';
import { isPublished, isReportProcessing } from './reportStatus.js';

/**
 * Status pills of a report. Draft/published and the public link are admin information
 * (clients only ever see published reports); processing is shown to everyone.
 * `overlap` ({ days, week }) flags a report that re-covers the end of the previous one.
 */
const ReportStatusBadges = ({ report, isAdminUser, hasPublicLink = !!report?.public_token, overlap = null, size = 'md' }) => (
  <>
    {isReportProcessing(report) && (
      <Badge tone="blue" size={size} icon={LuLoaderCircle} className="[&>svg]:animate-spin">
        {report?.steps?.dump === 'started' ? 'Génération en cours' : 'Traitement en cours'}
      </Badge>
    )}
    {report?.steps?.dump === 'failed' && !isReportProcessing(report) && (
      <Badge tone="red" size={size} title="Relancez avec Régénérer">Échec de la récupération</Badge>
    )}
    {isAdminUser && report?.failed_analyses > 0 && !isReportProcessing(report) && (
      <Badge tone="red" size={size} title="Ouvrez le rapport puis Régénérer">
        {report.failed_analyses > 1 ? `${report.failed_analyses} analyses en échec` : 'Analyse en échec'}
      </Badge>
    )}
    {isSnapshot(report) && !isReportProcessing(report) && report.steps?.dump !== 'failed' && (report.dumped_at
      ? (
        <Badge tone="blue" size={size} icon={LuCamera}>
          Instantané · complété le {formatParisInstant(report.period_end, { separator: ' à ' })}
        </Badge>
      )
      : <Badge tone="amber" size={size} title="Aucune donnée récupérée pour l'instant">Incomplet</Badge>)}
    {overlap && <Badge tone="slate" size={size}>reprend {formatDays(overlap.days)} j de S{overlap.week}</Badge>}
    {isAdminUser && (isPublished(report)
      ? <Badge tone="green" size={size} dot>Publié</Badge>
      : <Badge tone="amber" size={size} dot>Brouillon</Badge>)}
    {isAdminUser && hasPublicLink && isPublished(report) && (
      <Badge tone="violet" size={size} icon={LuLink} title="Un lien de partage public est actif">Lien public</Badge>
    )}
  </>
);

export default ReportStatusBadges;
